module.exports = __webpack_public_path__ + "img/syndic_illu.e93ebfb5.png";